export enum CrosswordDimension {
  Across = 'across',
  Down = 'down',
}
